/** Copyright © 2013-2025 DataYes, All Rights Reserved. */

import { getConfig } from 'utils/common';

export const API_ROOT = getConfig('API_ROOT');
export const RRP_ROOT = getConfig('RRP_ROOT');
export const RRP_API_ROOT = `${RRP_ROOT}/web`;
export const RRP_API_ROOT_MOBILE = `${RRP_ROOT}/mobile`;
export const MAMMON_ROOT = getConfig('MAMMON_ROOT');
export const MAMMON_API_ROOT = `${MAMMON_ROOT}/web`;
export const SCRM_ROOT = getConfig('SCRM_ROOT');
export const FUND_ROOT = getConfig('FUND_ROOT');
export const MEDIA_ROOT = getConfig('MEDIA_ROOT');
export const INFOSYNC_ROOT = getConfig('INFOSYNC_ROOT');
export const AIROBOT_ROOT = getConfig('AIROBOT_ROOT');
export const ALADDIN_INFO_ROOT = getConfig('ALADDIN_INFO_ROOT');
export const SCRM_API_ROOT = `${SCRM_ROOT}/web`;
export const MEDIA_API_ROOT = `${MEDIA_ROOT}/web`;
export const INFOSYNC_API_ROOT = `${INFOSYNC_ROOT}/web`;
export const AIROBOT_API_ROOT = `${AIROBOT_ROOT}/web`;
export const ALADDIN_INFO_API_ROOT = `${ALADDIN_INFO_ROOT}/web`;

export const RRP_WECHAT_ROOT = getConfig('RRP_WECHAT_ROOT');

export const ROBO_URL = getConfig('ROBO_URL');
export const M_ROBO_URL = getConfig('M_ROBO_URL');
export const AMS_URL = getConfig('AMS_URL');
export const FILE_URL = getConfig('FILE_URL');
export const STORAGE_ROOT = getConfig('STORAGE_ROOT');
export const INTELLIGENCE_ROOT = getConfig('INTELLIGENCE_ROOT');
export const INTELLIGENCE_API_ROOT = `${INTELLIGENCE_ROOT}/web`;

// 免费体验地址
export const FREE_EXPR = `${M_ROBO_URL}/rrpactivity/free-trail?uuid=`;
